import React from 'react';
import { connect } from 'react-redux';
import { redirectToLogin } from 'actions/authentication';

export function requireAuthentication(Component) {

  class AuthenticatedComponent extends React.Component {

    componentWillMount() {
      this.checkAuth();
    }

    componentWillReceiveProps() {
      this.checkAuth();
    }

    checkAuth() {
      let token = this.props.token;
      let localToken = localStorage.token;

      let apikey = this.props.location.query["apikey"];
      let localApikey = localStorage.apikey;
      let hasAPIKey = ((apikey && apikey.length > 0) || (localApikey && localApikey.length > 0));
      let hasToken = !(token == undefined || token === null || localToken == undefined || localToken === null)
      if (!hasToken && !hasAPIKey) {
        this.props.dispatch(redirectToLogin());
        console.log("token", token)
        console.log("localToken", localToken)
        console.log("apikey", apikey)
        console.log("localApikey", localApikey)

      }
    }

    render() {
      return (
        <React.Fragment>
          {<Component {...this.props} />}
        </React.Fragment>
      )
    }
  }

  const mapStateToProps = (state) => ({
    token: state.authReducer.token
  });

  function mapDispatchToProps(dispatch) {
    return {
      dispatch
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent);

}



// WEBPACK FOOTER //
// ./src/components/common/authenticatedComponent.jsx